module.exports = __webpack_public_path__ + "static/media/TypescriptLogo.b8a005be.png";